var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c("div", { staticClass: "main-content" }, [
          _c("div", { staticClass: "operations" }, [
            _c(
              "div",
              { staticClass: "filters" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      inline: true,
                      "label-width": "70px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "el-form-item-wrapper" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "baseInfo.customsCommodityCode.code"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "260px" },
                              attrs: { size: "mini" },
                              on: {
                                change: function($event) {
                                  _vm.searchConditions.pageNum = 1
                                }
                              },
                              model: {
                                value: _vm.searchConditions.code,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchConditions, "code", $$v)
                                },
                                expression: "searchConditions.code"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "baseInfo.customsCommodityCode.commodityName"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "260px" },
                              attrs: { size: "mini" },
                              on: {
                                change: function($event) {
                                  _vm.searchConditions.pageNum = 1
                                }
                              },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.fetchCommodityCodeList($event)
                                }
                              },
                              model: {
                                value: _vm.searchConditions.commodityName,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.searchConditions,
                                    "commodityName",
                                    $$v
                                  )
                                },
                                expression: "searchConditions.commodityName"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _c("div", { staticClass: "triggers" }, [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { height: "28px" },
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.fetchCommodityCodeList }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
                  )
                ],
                1
              )
            ])
          ]),
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c("cargo-ag-grid", {
                attrs: {
                  "config-module": "100401",
                  "grid-params": _vm.gridParams,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.searchConditions.total > 0,
                    expression: "searchConditions.total>0"
                  }
                ],
                attrs: {
                  "config-module": "100401",
                  total: _vm.searchConditions.total,
                  page: _vm.searchConditions.pageNum,
                  limit: _vm.searchConditions.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageSize", $event)
                  },
                  pagination: _vm.fetchCommodityCodeList
                }
              })
            ],
            1
          )
        ])
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog",
          attrs: {
            slot: "reference",
            "close-on-click-modal": false,
            visible: _vm.isShowCustomsCommodityCodeMaintain,
            title: _vm.$t(
              "baseInfo.customsCommodityCode.customsCommodityCodeMaintain"
            ),
            "inline-message": "",
            width: "50%"
          },
          on: {
            "update:visible": function($event) {
              _vm.isShowCustomsCommodityCodeMaintain = $event
            }
          },
          slot: "reference"
        },
        [
          _c(
            "el-form",
            {
              ref: "customsCommodityCodeForm",
              attrs: {
                model: _vm.customsCommodityCodeForm,
                "label-width": "120px",
                "label-position": "right"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("baseInfo.customsCommodityCode.countryCode"),
                    prop: "countryCode"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { size: "mini" },
                    model: {
                      value: _vm.customsCommodityCodeForm.countryCode,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.customsCommodityCodeForm,
                          "countryCode",
                          $$v
                        )
                      },
                      expression: "customsCommodityCodeForm.countryCode"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("baseInfo.customsCommodityCode.code"),
                    prop: "code"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { size: "mini" },
                    model: {
                      value: _vm.customsCommodityCodeForm.code,
                      callback: function($$v) {
                        _vm.$set(_vm.customsCommodityCodeForm, "code", $$v)
                      },
                      expression: "customsCommodityCodeForm.code"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t(
                      "baseInfo.customsCommodityCode.commodityName"
                    ),
                    prop: "commodityName"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { size: "mini" },
                    model: {
                      value: _vm.customsCommodityCodeForm.commodityName,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.customsCommodityCodeForm,
                          "commodityName",
                          $$v
                        )
                      },
                      expression: "customsCommodityCodeForm.commodityName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("baseInfo.customsCommodityCode.mfnRate"),
                    prop: "mfnRate"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { size: "mini" },
                    model: {
                      value: _vm.customsCommodityCodeForm.mfnRate,
                      callback: function($$v) {
                        _vm.$set(_vm.customsCommodityCodeForm, "mfnRate", $$v)
                      },
                      expression: "customsCommodityCodeForm.mfnRate"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("baseInfo.customsCommodityCode.generalRate"),
                    prop: "generalRate"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { size: "mini" },
                    model: {
                      value: _vm.customsCommodityCodeForm.generalRate,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.customsCommodityCodeForm,
                          "generalRate",
                          $$v
                        )
                      },
                      expression: "customsCommodityCodeForm.generalRate"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("baseInfo.customsCommodityCode.vat"),
                    prop: "vat"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { size: "mini" },
                    model: {
                      value: _vm.customsCommodityCodeForm.vat,
                      callback: function($$v) {
                        _vm.$set(_vm.customsCommodityCodeForm, "vat", $$v)
                      },
                      expression: "customsCommodityCodeForm.vat"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("baseInfo.customsCommodityCode.legalUnit"),
                    prop: "legalUnit"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { size: "mini" },
                    model: {
                      value: _vm.customsCommodityCodeForm.legalUnit,
                      callback: function($$v) {
                        _vm.$set(_vm.customsCommodityCodeForm, "legalUnit", $$v)
                      },
                      expression: "customsCommodityCodeForm.legalUnit"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("baseInfo.customsCommodityCode.secondUnit"),
                    prop: "secondUnit"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { size: "mini" },
                    model: {
                      value: _vm.customsCommodityCodeForm.secondUnit,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.customsCommodityCodeForm,
                          "secondUnit",
                          $$v
                        )
                      },
                      expression: "customsCommodityCodeForm.secondUnit"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t(
                      "baseInfo.customsCommodityCode.superviseMode"
                    ),
                    prop: "superviseMode"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { size: "mini" },
                    model: {
                      value: _vm.customsCommodityCodeForm.superviseMode,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.customsCommodityCodeForm,
                          "superviseMode",
                          $$v
                        )
                      },
                      expression: "customsCommodityCodeForm.superviseMode"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("baseInfo.customsCommodityCode.mscCommodity"),
                    prop: "mscCommodity"
                  }
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      maxlength: 255,
                      rows: 6,
                      size: "mini"
                    },
                    model: {
                      value: _vm.customsCommodityCodeForm.mscCommodity,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.customsCommodityCodeForm,
                          "mscCommodity",
                          $$v
                        )
                      },
                      expression: "customsCommodityCodeForm.mscCommodity"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "medium ", type: "primary" },
                  on: { click: _vm.submitCustomsCommodityCode }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "medium " },
                  on: { click: _vm.cancelSaveOrEdit }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }